<template>
  <b-modal id="rtsmErrorModal" ref="rtsm-error-modal" :title="getModalTitle()" class="rtsm-error-modal" @hidden="hideModal" hide-footer>
    <div class="rtsm-error-modal-body">
      <template v-if="shouldMarkAsResolved">
        <p>Are you sure you wish to resolve the Participant RTSM Integration Error?</p>
        <p>This action cannot be undone.</p>
        <div id="modal-footer" class="d-flex justify-content-end mb-20 mt-24">
          <b-button v-b-modal.modal-close_visit variant="outline-secondary" class="btn btn-sm m-1 pl-20 pr-20" @click="hideModal">
            Cancel
          </b-button>
          <button v-b-modal.modal-close_visit class="modal-btn btn btn-info btn-primary btn-sm m-1 pl-16 pr-16 pt-8 pb-8" @click="handleResolveError">
            Yes, resolve
          </button>
        </div>
      </template>
      <template v-else>
        <p>{{ integrationStatus }}</p>
        <p>Please resolve this issue through taking action in the RTSM system. Once this action is complete, you can mark the action as resolved.</p>
        <div id="modal-footer" class="d-flex justify-content-end mb-0 mt-24">
          <b-button v-b-modal.modal-close_visit variant="outline-secondary" class="btn btn-sm m-1 pl-20 pr-20 mr-16" @click="hideModal">
            Cancel
          </b-button>
          <button v-b-modal.modal-close_visit class="modal-btn btn btn-info btn-primary btn-sm m-1 pl-16 pr-16 pt-8 pb-8" @click="handleOk">
            Mark as resolved
          </button>
        </div>
      </template>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "rtsm-error-modal",
  props: {
    integrationStatus: {
      type: String,
      required: true
    },
    participantId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      shouldMarkAsResolved: false
    };
  },
  methods: {
    getModalTitle() {
      return this.shouldMarkAsResolved ? "Confirm Error Resolution" : "Participant RTSM Integration Error";
    },
    hideModal() {
      this.$refs["rtsm-error-modal"].hide();
      this.shouldMarkAsResolved = false;
    },
    handleOk() {
      this.shouldMarkAsResolved = true;
    },
    handleResolveError() {
      this.$api
        .deleteIntegrationParticipantError(this.participantId)
        .then(() => {
          this.$toastr.success("RTSM Integration error resolved.");
          this.hideModal();
        })
        .catch(() => {
          this.$toastr.error("An error occured while trying to resolve participant errors.");
        });
    }
  }
};
</script>

<style scoped lang="scss">
.btn-outline-secondary {
  border: none !important;
}

.btn {
  font-size: 14px;
}
.rtsm-error-modal {
  /deep/ .modal-dialog {
    max-width: 443px;
  }
  /deep/ .modal-header {
    border-bottom: none;
  }

  .rtsm-error-modal-body {
    color: #666669;
  }

  color: #4a4a4a;
}
</style>
